import {
  PettyCashRequisitionStateTypes,
  PettyCashRequisitionActionTypes,
} from "./PettyCashRequisition.type";
import { resetApiCallState } from "../Utils";

const INITIAL_STATE: PettyCashRequisitionStateTypes = {
  fetchAll: resetApiCallState([]),
  fetchOne: resetApiCallState({}),
};

const PettyCashRequisitionReducer = (
  state: PettyCashRequisitionStateTypes = INITIAL_STATE,
  action: any
): PettyCashRequisitionStateTypes => {
  switch (action.type) {
    case PettyCashRequisitionActionTypes.FETCH_ALL_PETTY_CASH_REQUISITION:
      return {
        ...state,
        fetchAll: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case PettyCashRequisitionActionTypes.FETCH_ALL_PETTY_CASH_REQUISITION_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case PettyCashRequisitionActionTypes.FETCH_ALL_PETTY_CASH_REQUISITION_FAILURE:
      return {
        ...state,
        fetchAll: {
          payload: [],
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case PettyCashRequisitionActionTypes.FETCH_ALL_PETTY_CASH_REQUISITION_SUCCESS:
      return {
        ...state,
        fetchAll: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    case PettyCashRequisitionActionTypes.FETCH_ONE_PETTY_CASH_REQUISITION:
      return {
        ...state,
        fetchOne: {
          error: null,
          payload: {},
          isPending: true,
          isSuccessful: false,
        },
      };
    case PettyCashRequisitionActionTypes.FETCH_ONE_PETTY_CASH_REQUISITION_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case PettyCashRequisitionActionTypes.FETCH_ONE_PETTY_CASH_REQUISITION_FAILURE:
      return {
        ...state,
        fetchOne: {
          payload: {},
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case PettyCashRequisitionActionTypes.FETCH_ONE_PETTY_CASH_REQUISITION_SUCCESS:
      return {
        ...state,
        fetchOne: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    default:
      return state;
  }
};

export default PettyCashRequisitionReducer;
